
import { Vue, Component } from "vue-property-decorator";
import InterviewsListing from "@/modules/interviews/components/InterviewsListing.vue";

@Component({ components: { InterviewsListing } })
export default class InterviewsIndex extends Vue {}
